export const transformPromocode = (promocodeData, code) => {
    return {
        duration: promocodeData.DurationDays,
        description: promocodeData.PromotionDescription,
        name: promocodeData.PromotionName,
        code,
    };
};
